export const categories = [
  {
    id: 'platform-features',
    name: '平台功能介绍',
    slug: 'platform-features',
    description: '全面了解 qiaojzx.cn 一站式综合服务平台的各项核心功能与服务模块',
    icon: 'ri-dashboard-3-line',
  },
  {
    id: 'register-login',
    name: '注册登录教程',
    slug: 'register-login',
    description: '详细的 qiaojzx.cn 账号注册与登录操作指南，帮助您快速完成账户设置',
    icon: 'ri-user-add-line',
  },
  {
    id: 'usage-tutorial',
    name: '使用教程',
    slug: 'usage-tutorial',
    description: '从入门到精通，掌握 qiaojzx.cn 平台各项功能的使用方法与技巧',
    icon: 'ri-book-open-line',
  },
  {
    id: 'service-advantages',
    name: '服务优势',
    slug: 'service-advantages',
    description: '了解 qiaojzx.cn 相较于传统服务方式的独特优势与核心竞争力',
    icon: 'ri-medal-line',
  },
  {
    id: 'faq',
    name: '常见问题',
    slug: 'faq',
    description: '汇总用户在使用 qiaojzx.cn 过程中最常遇到的问题及详细解答',
    icon: 'ri-question-answer-line',
  },
];

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);